import { useEffect, useState } from 'react';

import LoadStatus from 'config/load_status';

import listLatestRecipes from 'domain/recipe/usecases/list_latest_recipes';

import delayed from 'utils/delayed';

const useLatestRecipes = () => {
  const [recipes, setRecipes] = useState([]);
  const [latestRecipesLoadStatus, setLatestRecipesLoadStatus] = useState(
    LoadStatus.LOADING
  );
  const [hasFinished, setHasFinished] = useState(false);

  useEffect(() => {
    if (latestRecipesLoadStatus !== LoadStatus.LOADING) return;

    const readData = async () => {
      try {
        const lastRecipe =
          recipes.length > 0 ? recipes[recipes.length - 1] : null;

        const newRecipes = await delayed(listLatestRecipes(lastRecipe), 25);

        if (!newRecipes.length) setHasFinished(true);
        setLatestRecipesLoadStatus(LoadStatus.DONE);
        setRecipes(recipes.concat(newRecipes));
      } catch (error) {
        setLatestRecipesLoadStatus(LoadStatus.ERROR);
        throw error;
      }
    };
    readData();
  }, [latestRecipesLoadStatus, recipes]);

  const loadMoreRecipes = () => {
    if (latestRecipesLoadStatus === LoadStatus.LOADING) return;
    setLatestRecipesLoadStatus(LoadStatus.LOADING);
  };

  return {
    loadMoreRecipes,
    recipes,
    hasFailed: latestRecipesLoadStatus === LoadStatus.ERROR,
    hasFinished,
  };
};

export default useLatestRecipes;
